export const LIMIT_FILE_UPLOAD_MAX_FILES = 999 as const;

export const LIMIT_ENTITY_SELECTOR_CHIPS = 6 as const;
